import React, { useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import trans, { isRTL } from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import { toast } from "react-toastify";
import { Segmented } from "antd";
import { OffcanvasBody } from "react-bootstrap";
import StepsOffcanvasFooter from "../../Helpers/Offcanvasfooter/StepsOffcanvasFooter";
import IRInformation from "./IRInformation/IRInformation";
import IRFormSubmit from "./IRInformation/IRFormSubmit";
import {
  useAddIRMutation,
  useEditIRMutation,
  useGetSingleIRQuery,
} from "../../../Redux/service/IR/IR";
import Loader from "../../Helpers/Loader/Loader";

export default function InspectionRequestBody({ preselectedLocation = null }) {
  const [submitAttempt, setSubmitAttempt] = useState(false);
  let { handleClose, isEditing, setReloadData, currentIRId } =
    useContext(popupcontext);

  let {
    data: Editvalues,
    isLoading,
    refetch,
  } = useGetSingleIRQuery(currentIRId, {
    skip: !currentIRId,
  });
  const [AddIR, { isLoading: AddLoading }] = useAddIRMutation();
  const [EditIR, { isLoading: EditLoading }] = useEditIRMutation();
  const [submitData, setSubmitData] = useState([]);
  const [confirmationData, setConfirmationData] = useState(
    isEditing ? Editvalues?.data?.formSubmission?.formData : [],
  );
  console.log("Confirmation Data", confirmationData);

  const steps = [
    { label: trans("information"), value: "information" },
    { label: trans("form submission"), value: "form submission" },
  ];
  const [activeOption, setActiveOption] = useState("information");

  let initialValues = {
    type: "IR",
    project_id: preselectedLocation?.project_id || null,
    discipline: null,
    zone_id: preselectedLocation?.zone_id || null,
    level_id: preselectedLocation?.building_id || null, // building_id maps to level_id in IR
    room_id: preselectedLocation?.level || null, // level (space poiId) maps to room_id in IR
    ready_date: null,
    form_id: null,
    fields: null,
    removed_attachments: [],
    edit_notes: "",
  };
  let validSchema = Yup.object({
    project_id: Yup.string().required(trans("Project is required")),
    // type: Yup.string().required(trans("Type is required")),
    form_id: Yup.string().required(trans("Form is required")),
    ready_date: Yup.string().required(trans("Ready Date is required")),
    discipline: Yup.string().required(trans("Discipline is required")),
  });
  let addIR = useFormik({
    initialValues,
    validationSchema: validSchema,
    onSubmit: async (val) => {
      try {
        if (isEditing) {
          val.fields = submitData;
          // Explicitly pass edit-only fields from current form state so they are never lost
          val.removed_attachments = Array.isArray(val.removed_attachments)
            ? val.removed_attachments
            : [];
          val.edit_notes = val.edit_notes || val.correction_notes || "";
          await EditIR({ id: currentIRId, val }).unwrap();
          toast.success(trans("IR Form Edited Successfully"), {
            autoClose: 800,
            rtl: localStorage.getItem("lang") === "ar" ? true : false,
          });
          setReloadData(true);
          refetch();
          handleClose("form");
        } else {
          val.fields = submitData;
          await AddIR(val).unwrap();
          toast.success(trans("IR Form Submitted Successfully"), {
            autoClose: 800,
            rtl: localStorage.getItem("lang") === "ar" ? true : false,
          });
          setReloadData(true);
          handleClose("form");
        }
      } catch (error) {
        console.log("errr", error);
        toast.error(`${error?.data?.message}`, {
          autoClose: 800,
          rtl: localStorage.getItem("lang") === "ar" ? true : false,
        });
      }
    },
  });
  useEffect(() => {
    if (Editvalues) {
      setSubmitData(Editvalues?.data?.formSubmission?.formData);
      setConfirmationData(Editvalues?.data?.formSubmission?.formData);
    }
  }, [Editvalues]);
  useEffect(() => {
    if (isEditing && Editvalues) {
      addIR.setValues((prev) => ({
        ...prev,
        project_id: Editvalues?.data?.project_id ?? null,
        discipline: Editvalues?.data?.discipline ?? null,
        zone_id: Editvalues?.data?.zone_id ?? null,
        level_id: Editvalues?.data?.level_id ?? null,
        room_id: Editvalues?.data?.room_id ?? null,
        ready_date: Editvalues?.data?.ready_date ?? null,
        form_id: Editvalues?.data?.form_id ?? null,
        fields: Editvalues?.data?.formSubmission?.formData ?? null,
        // Keep user's removal selection and edit notes; only set defaults on first load
        removed_attachments: prev.removed_attachments ?? [],
        edit_notes: prev.edit_notes ?? "",
      }));
    } else if (!isEditing && preselectedLocation) {
      // Prefill form with preselected location data
      addIR.setValues({
        type: "IR",
        project_id: preselectedLocation.project_id || null,
        zone_id: preselectedLocation.zone_id || null,
        level_id: preselectedLocation.building_id || null, // building_id maps to level_id
        room_id: preselectedLocation.level || null, // level (space poiId) maps to room_id
        discipline: null,
        ready_date: null,
        form_id: null,
        fields: null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Editvalues, preselectedLocation, isEditing]);
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitAttempt(true);

    // Helper: Flatten fields including containers
    const flattenFields = (fields) => {
      return fields.flatMap((field) => {
        if (field.name === "Container" && Array.isArray(field.container)) {
          return [field, ...flattenFields(field.container)];
        }
        return field;
      });
    };

    const allFields = flattenFields(confirmationData);

    let updatedSubmitData = [...submitData];

    const missingRequiredFields = allFields.filter((field) => {
      const submittedField = updatedSubmitData.find((i) => i.key === field.key);
      const isRequired = field?.required?.value;

      // Special case: Checkbox & Toggle
      if (["Checkbox", "Toggle"].includes(field.name)) {
        if (!submittedField) {
          updatedSubmitData.push({
            key: field.key,
            name: field.name,
            title: field.title,
            value: false, // ✅ default false
          });
          return isRequired; // still missing if required
        }
        return false;
      }

      // Normal required input
      return (
        isRequired &&
        (!submittedField ||
          submittedField.value === "" ||
          submittedField.value === undefined ||
          submittedField.value === "[]" ||
          submittedField.value.length === 0)
      );
    });

    if (missingRequiredFields.length > 0) {
      missingRequiredFields.forEach((field) => {
        addIR.setFieldTouched(`fields[${field.key}].value`, true, false);
      });
      addIR.validateForm(false);
      // ✅ Update with default checkbox/toggle values if added
      setSubmitData(updatedSubmitData);

      console.warn("Missing required:", missingRequiredFields);
      return; // ❌ stop submitting
    }

    // ✅ Submit now passes all validation
    setSubmitData(updatedSubmitData);
    addIR.handleSubmit(e);
  };

  const step = steps?.findIndex((i) => i?.value === activeOption);

  const disableNext = () => {
    if (step === 0) {
      if (
        !isEditing &&
        (addIR.values.project_id === null ||
          addIR.errors.project_id ||
          addIR.values.form_id === null ||
          addIR.errors.form_id ||
          addIR.values.ready_date === null ||
          addIR.errors.ready_date ||
          addIR.values.discipline === null ||
          addIR.errors.discipline ||
          addIR.values.type === null ||
          addIR.errors.type)
      ) {
        return true;
      }
    } else {
      return false;
    }
  };
  let disable = disableNext();
  console.log("AddData", addIR);
  if (AddLoading)
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  if (EditLoading)
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );
  return (
    <>
      <Segmented
        options={steps.map((i, index) => ({
          label: i.label,
          value: i.value,
        }))}
        style={{ textTransform: "capitalize" }}
        onChange={(value) => {
          console.log("Value", value);
          if (!disable) setActiveOption(value);
          if (value === "information" || activeOption === "information") {
            addIR.setFieldTouched("project_id", true, true);
            addIR.setFieldTouched("type", true, true);
            addIR.setFieldTouched("form_id", true, true);
            addIR.setFieldTouched("ready_date", true, true);
            addIR.setFieldTouched("discipline", true, true);
          }
        }}
        onClick={(value) => {
          if (value === "information" || activeOption === "information") {
            addIR.setFieldTouched("project_id", true, true);
            addIR.setFieldTouched("type", true, true);
            addIR.setFieldTouched("form_id", true, true);
            addIR.setFieldTouched("ready_date", true, true);
            addIR.setFieldTouched("discipline", true, true);
          }
        }}
        value={activeOption}
        size="large"
        block
      />
      <OffcanvasBody dir={!isRTL ? "ltr" : "rtl"}>
        {activeOption === "information" && (
          <IRInformation
            addData={addIR}
            preselectedLocation={preselectedLocation}
            isEditing={isEditing}
          />
        )}
        {activeOption === "form submission" && (
          <IRFormSubmit
            addData={addIR}
            submitData={submitData}
            setSubmitData={setSubmitData}
            confirmationData={confirmationData}
            setConfirmationData={setConfirmationData}
            isEditing={isEditing}
            editValues={Editvalues}
          />
        )}
      </OffcanvasBody>
      {/* <UserInfo addData={addUser} /> */}
      <form onSubmit={handleSubmit} dir={!isRTL ? "ltr" : "rtl"}>
        <StepsOffcanvasFooter
          step={steps?.findIndex((i) => i?.value === activeOption)}
          totalsteps={steps?.length - 1}
          setActiveOption={setActiveOption}
          segment={steps}
          addData={addIR}
          submitAttempt={submitAttempt}
          handleSubmit={handleSubmit}
          disableNext={disableNext}
        />{" "}
      </form>
    </>
  );
}
